import React, { useEffect, useState } from "react";
import { TrendingDown } from "lucide-react";
import { api } from "../lib/api";

const ROWS = [["landing_view", "Landing"], ["click_buy", "Clique CTA"], ["checkout_redirect", "Checkout"], ["stripe_checkout_created", "Sessão Stripe"], ["payment_pending", "Pgto. pendente"], ["payment_approved", "Pgto. aprovado"], ["payment_refunded", "Reembolso"]];

// Admin → Funil por mercado (read-only aggregation of analytics_events + purchases).
export function FunnelMetrics() {
  const [data, setData] = useState(null);
  const [days, setDays] = useState(30);
  useEffect(() => { api.get(`/admin/funnel?days=${days}`).then(({ data }) => setData(data)).catch(() => {}); }, [days]);
  if (!data) return null;
  const cols = [...data.markets, "—"];
  const n = (ev, m) => data.events?.[ev]?.[m] ?? 0;
  const approved = (m) => Object.values(data.purchases?.[m] || {}).reduce((a, p) => a + (p.approved || 0), 0);
  return (
    <div className="mt-12" data-testid="admin-funnel">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2"><TrendingDown className="h-5 w-5 text-xmas-gold" /><h2 className="font-display text-xl text-xmas-snow">Funil por mercado</h2></div>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} data-testid="funnel-days" className="rounded-lg border border-xmas-gold/20 bg-xmas-navy/50 px-3 py-1.5 text-xs text-xmas-snow outline-none">
          {[7, 14, 30, 90].map((d) => <option key={d} value={d}>{d} dias</option>)}
        </select>
      </div>
      <div className="glass overflow-x-auto rounded-2xl p-4">
        <table className="w-full text-xs" data-testid="funnel-table">
          <thead><tr className="text-left text-xmas-slate"><th className="py-2 pr-3">Etapa</th>{cols.map((c) => <th key={c} className="px-2 py-2 text-right">{c}</th>)}</tr></thead>
          <tbody>
            {ROWS.map(([ev, label]) => (
              <tr key={ev} className="border-t border-white/5 text-xmas-snow"><td className="py-2 pr-3">{label}</td>{cols.map((c) => <td key={c} className="px-2 py-2 text-right font-mono-num">{n(ev, c)}</td>)}</tr>
            ))}
            <tr className="border-t border-xmas-gold/20 font-semibold text-xmas-gold" data-testid="funnel-purchases"><td className="py-2 pr-3">Compras aprovadas</td>{cols.map((c) => <td key={c} className="px-2 py-2 text-right font-mono-num">{approved(c)}</td>)}</tr>
            <tr className="text-xmas-champagne" data-testid="funnel-rate"><td className="py-2 pr-3">Checkout → compra</td>{cols.map((c) => { const ck = n("checkout_redirect", c); return <td key={c} className="px-2 py-2 text-right font-mono-num">{ck ? `${Math.round(approved(c) / ck * 100)}%` : "—"}</td>; })}</tr>
          </tbody>
        </table>
        <div className="mt-4 grid grid-cols-2 gap-3 text-[11px] text-xmas-slate sm:grid-cols-5">
          {Object.entries(data.checkout_dimensions || {}).map(([k, arr]) => (
            <div key={k} data-testid={`funnel-dim-${k}`}><p className="mb-1 uppercase tracking-wider text-xmas-gold/80">{k}</p>{arr.length ? arr.map((a) => <p key={a.key}>{a.key}: <span className="text-xmas-snow">{a.count}</span></p>) : <p>—</p>}</div>
          ))}
        </div>
        <p className="mt-3 text-[11px] text-xmas-slate">"—" = evento sem mercado registrado. Dados reais, sem estimativas.</p>
      </div>
    </div>
  );
}
